import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledMenu = styled.div `
    margin: 0 -20px 30px -20px;

    @media only screen and (min-width: 768px) {
        margin: 0 -8px 30px -20px;
    }
`;
const Menu = ({ children }) => (_jsx(StyledMenu, { children: children }));
export default Menu;
